<template>
	<div class="message-content-wrap">
		<div class="msg-list">
			<div v-if="messageListData.length>0">
				<el-scrollbar wrapClass="yf-container" viewClass="yf-content" wrapStyle="color:'#fff';fontSize:'16px';"
					viewStyle="color:'#fff';fontSize:'16px';height:150px;" :native="false" :noresize="true" tag="div">
					<div @click="tiDetail(item)" v-for="(item,index) in messageListData" class="msg-item" :key="index">
						<span v-if="item.mtype==0" style="color: #1E9FFF;">【全部】</span>
						<span v-if="item.mtype==1" style="color: #1E9FFF;">【平台公告】</span>
						<span v-if="item.mtype==2" style="color: #1E9FFF;">【审核通知】</span>
						<span>{{item.title}}</span>
					</div>
					<p v-if="loading"
						style="height: 40px;text-align:center;display: flex;justify-content: center;align-items: center;">
						<span style="margin-right: 6px">加载中</span><i class="el-icon-loading"></i>
					</p>
					<div v-if="pagenums==messageListData.length" style="text-align: center;line-height: 40px;">到底了~</div>
				</el-scrollbar>
			</div>
			<div v-else style="text-align: center;">暂无新消息</div>
		</div>

	</div>
</template>
<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		props: {
			tabIndex: {
				default: 0
			},
			tabData: {
				default: {}
			},
			messageNum: {
				default: {}
			}
		},

		mounted() {
			this.getUnready()
			this.addCommentFun()
		},
		computed: {
			...mapState('message', ['stateMessageUnreadyNumber']),
			isLoagin() {
				if (this.messageListData.length < this.messageNum[this.tabData[this.tabIndex].value]) {
					return true
				} else {
					return false
				}
			}
		},
		data() {
			return {
				messageListData: [{
						"id": 13,
						"mtype": 2,
						"desc": "您的课程：「测试课程有效期」已通过审核。",
						"title": "课程主体",
						"created_time": "2022-05-13 11:33:40",
						"is_ready": 1
					},
					{
						"id": 11,
						"mtype": 2,
						"desc": "您的课程：「第一分类标题展示字数测试，人类文明的延续 香火鼎盛的世界」已通过审核。",
						"title": "课程主体",
						"created_time": "2022-05-12 11:02:00",
						"is_ready": 1
					},
					{
						"id": 5,
						"mtype": 1,
						"desc": "fsdfa",
						"title": "dafas",
						"created_time": "2022-03-18 20:26:55",
						"is_ready": 2
					},
					{
						"id": 5,
						"mtype": 1,
						"desc": "fsdfa",
						"title": "dafas",
						"created_time": "2022-03-18 20:26:55",
						"is_ready": 1
					}

				],
				pageObj: {
					page: 1,
					page_size: 4,
					mtype: 1
				},
				loading:'',
				pagenums:0,
			}
		},
		methods: {
			...mapActions('message', ['messageUnready']),
			tiDetail(ite) {
				this.$router.push({
					path:  this.staticPath + "detailMessage?id="+ite.id,
				})
			},
			async getUnready(key) { //
				if (!key) {
					this.pageObj = {
						page: 1,
						page_size: 4,
					}
				}
				this.pageObj.mtype = this.tabIndex
				console.log(854,this.pageObj);
				let res = await this.messageUnready(this.pageObj)
				this.loading=false
				this.pagenums=res.total
				if(this.pageObj.page==1){
					this.messageListData = res.data
				}else{
					this.messageListData.push(...res.data)
				}
			},
			addCommentFun() {
			
				if(this.pagenums>0&&this.pagenums==this.messageListData.length){
					return
				}
				this.$nextTick(() => {
					let dom = document.querySelector(`.el-scrollbar__wrap`)
					console.log(564, dom);
					dom.addEventListener('scroll', (e) => {
						if (this.messageListData.length >= this.messageNum[this.tabData[this.tabIndex].value]) {
							return
						}
						console.log(112233,this.pagenums,this.messageListData.length);
						let clientHeight = dom.clientHeight
						let scrollHeight = dom.scrollHeight
						if (clientHeight + e.target.scrollTop >= scrollHeight&&!this.loading) {
							this.loading = true
							this.pageObj.page++
							this.getUnready(true)
						}
						
					}, false)
				})
			},
		},
		watch: {
			tabIndex() {
				this.getUnready()
			}
		}
	}
</script>
<style lang="less">
	.msg-item {
		background-color: rgba(245, 247, 250, 1);
		padding: 10px 5px 10px 5px;
		margin-top: 8px;
		cursor: pointer;
	}
</style>
